import type { FonteReproducao } from '@/shared/types';

/** `audio_captura` só se aplica fora do modo playlist (HDMI, janela, live). */
export function resolverAudioCaptura(
  origem: FonteReproducao,
  audio: 'playlist' | 'captura',
): 'playlist' | 'captura' {
  return origem === 'playlist' ? 'playlist' : audio;
}
